import { useState } from "react";

import styles from "./Accordion.module.scss";

import ChevronDown from "~/assets/chevron-down-next-step.svg";
import { useAmplitudeTracking } from "~/tracking/useAmplitudeTracking";

type AccordionProps = {
  title: string;
  subTitle?: string;
  children: React.ReactNode;
};

const Accordion = ({ title, subTitle, children }: AccordionProps) => {
  const [activityOpen, setActivityOpen] = useState(false);

  const { trackAccordionExpanded } = useAmplitudeTracking();

  const handleActivityClick = () => {
    setActivityOpen(!activityOpen);
    if (!activityOpen) {
      trackAccordionExpanded({ topic: title });
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.title}>{title}</p>
        <p className={styles.subTitle}>{subTitle}</p>
        <button className={styles.chevron} onClick={handleActivityClick}>
          {activityOpen ? (
            <img
              src={ChevronDown}
              className={`${styles.chevron}  ${styles.rotate}`}
            />
          ) : (
            <img src={ChevronDown} className={styles.chevron} />
          )}
        </button>
      </div>
      {
        <div
          className={`${styles.content} ${
            activityOpen ? styles.contentOpen : ""
          }`}
        >
          {children}
        </div>
      }
    </div>
  );
};

export default Accordion;
